import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
*   data: import('./data').ContactListDataEntity,
*   ui: import("./ui").ContactListsUIReducer,
* }} ContactListReducer
*/

export default combineReducers({
  ui,
  data,
});
